module.exports = __webpack_public_path__ + "static/img/videoFailed.e3fb24da.png";